import { render, staticRenderFns } from "./partner-project-info.pug?vue&type=template&id=c80f3f42&lang=pug&"
import script from "./partner-project-info.ts?vue&type=script&lang=ts&"
export * from "./partner-project-info.ts?vue&type=script&lang=ts&"
import style0 from "./partner-project-info.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports